import * as React from 'react';
import { Page } from 'components/Layout';
import { Box, Link, Typography } from '@mui/material';
import { RouteComponentProps, withRouter } from 'react-router';
import { ApplicationRoutingState } from '../../types/application.types';
import { pushPreviousRoutedPathname } from '../../helpers/routing';

interface Props {
    submissionId: string;
}

const EndorsmentNote: React.FunctionComponent<Props & RouteComponentProps<{}, {}, ApplicationRoutingState>> = (
    props
) => {
    const { submissionId, history, location } = props;

    const onClick = () => {
        const link = `/submission/${submissionId}/overview`;
        pushPreviousRoutedPathname(location.pathname, location);
        history.push(link, { ...location.state });
    };

    return (
        <Page title="Endorsing Submission">
            <Typography variant="body2">
                This submission is an endorsment. For complete details on the endorsing submission, please consult
                <Link href={''} style={{ margin: '0 6px' }} onClick={onClick} underline="hover">
                    <Box
                        component="span"
                        display={'inline'}
                        fontWeight={'fontWeightBold'}
                        style={{ textDecoration: 'underline' }}
                    >
                        submission #{submissionId}
                    </Box>
                </Link>
                .
            </Typography>
        </Page>
    );
};

export default withRouter(EndorsmentNote);
